import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {ErrorInterceptor} from './error.interceptor';
import { ApiRestInterceptor } from './api-rest.interceptor';
import { DataUpdateBlockInterceptor } from './data-update-block.interceptor';

// Orden importa: ApiRest inyecta token → DataUpdateBlock filtra escrituras
// según status → Error maneja respuestas. Mantener este orden al agregar
// interceptors nuevos.
export const HttpInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: ApiRestInterceptor , multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DataUpdateBlockInterceptor , multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor , multi: true },
];
